export enum FeatureToggle {
  OFFER_DISCOUNT_BOX = "offerDiscountBox",
  BI_8804 = "BI-8804",
  LOGIN_WITH_BANK_ID = "loginWithBankId",
  BLOCKING_PAGE = "blockingPage",
  SKIP_LOGIN_IF_EXISTING_CART = "skipLoginIfExistingCart",
  OFFER_ACCEPT_REDIRECT = "offerAcceptRedirect",
  OFFER_ACCEPT_USER_LOCK = "offerAcceptUserLock",
  REDIRECT_TO_LOGIN_PAGE = "redirectToLoginPage",
  SSX_513 = "SSX-513", // Toggle for Electric scooter - disableKaskoForElectricScooter
}
